"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M17.0001 14.5001c-.3-2.9-3.8-4.9-8-4.45-2.45.25-4.7 1.3-5.95 2.8-.8.95-1.15 2.05-1.05 3.15.25 2.65 3.2 4.5 6.9 4.5.35 0 .7 0 1.1-.05 2.45-.25 4.7-1.3 5.95-2.8.8-.95 1.15-2.05 1.05-3.15z",
    fill: "#fff"
  }), _react.default.createElement("path", {
    d: "M9.9 19.45C6.35 19.8 3.25 18.2 3 15.9s2.5-4.5 6.05-4.85c3.6-.35 6.65 1.25 6.9 3.55.25 2.35-2.45 4.5-6.05 4.85zm7.45-7.5c-.3-.1-.5-.15-.35-.55.35-.85.4-1.6 0-2.15-.7-1-2.65-.95-4.85-.05 0 0-.7.3-.5-.25.35-1.1.3-2-.25-2.5-1.2-1.2-4.4.05-7.15 2.75C2.2 11.25 1 13.4 1 15.25 1 18.85 5.6 21 10.15 21c5.9 0 9.85-3.4 9.85-6.1 0-1.65-1.4-2.55-2.65-2.95z",
    fill: "#D32F2F"
  }), _react.default.createElement("path", {
    d: "M10.45 15.1999c-.15.25-.45.4-.7.3-.25-.1-.3-.4-.2-.65.15-.25.45-.4.65-.25.3.05.35.3.25.6zm-1.65 1.2c-.35.5-1.15.75-1.75.5-.6-.25-.75-.85-.4-1.3.35-.5 1.1-.7 1.7-.5.65.2.85.8.45 1.3zm1.45-3.8c-1.75-.45-3.7.4-4.45 1.9-.75 1.55-.05 3.25 1.75 3.8 1.8.6 3.95-.3 4.7-1.95.75-1.6-.2-3.3-2-3.75z",
    fill: "#263238"
  }), _react.default.createElement("path", {
    d: "M21.95 10a.75.75 0 1 0-.0001 1.4998A.75.75 0 0 0 21.95 10z",
    fill: "#F9A825"
  }), _react.default.createElement("path", {
    d: "M22.65 11c-.1.3-.4.5-.7.5-.4 0-.75-.35-.75-.75 0-.1 0-.2.05-.3.15-.45.25-.95.25-1.45 0-2.5-2-4.5-4.5-4.5-.2 0-.45 0-.65.05h-.1c-.4 0-.75-.35-.75-.75s.35-.75.75-.75C16.5 3 16.75 3 17 3c3.3 0 6 2.7 6 6 0 .7-.1 1.35-.35 2zM20 9c0-1.65-1.35-3-3-3h-.4c-.35.05-.65.35-.65.75s.35.75.75.75h.25c.85 0 1.5.65 1.5 1.5 0 .15-.05.35-.1.5-.05.1-.05.15-.05.25 0 .4.35.75.75.75.3 0 .55-.2.7-.45V10c0-.05 0-.05.05-.1.15-.3.2-.6.2-.9z",
    fill: "#F9A825"
  })];
};

exports.default = _default;